import service from '../service/luckyMoney'
import CONSTANT from '../constant/luckyMoney'

export default {
  joinRedPackage ({commit}, data) {
    return new Promise((resolve, reject) => {
      return service.joinRedPackage(data).then(result => {
          resolve(result)
          return result
      }, e => {
          reject(e)
      })
    })
  },
  getLuckyMoneyDetail ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getLuckyMoneyDetail(data).then(result => {
                resolve(result)
                commit(CONSTANT.LUCKYMONEY_GETLUCKYYMONEYDETAIL_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.LUCKYMONEY_GETLUCKYYMONEYDETAIL_ERROR, e)
            })
        })
    },
    getLuckyMoneyRecord ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getLuckyMoneyRecord(data).then(result => {
                resolve(result)
                commit(CONSTANT.LUCKYMONEY_GETLUCKYYMONEYRECORD_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.LUCKYMONEY_GETLUCKYYMONEYRECORD_ERROR, e)
            })
        })
    },
    /*yeoman-template-point-1*/
}
